import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle, X } from 'lucide-react';

const ThankYouPopup = ({ isOpen, onClose }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4"
          onClick={onClose}
        >
          <motion.div 
            initial={{ scale: 0.8, y: 50, opacity: 0 }}
            animate={{ scale: 1, y: 0, opacity: 1 }}
            exit={{ scale: 0.8, y: 50, opacity: 0 }}
            onClick={(e) => e.stopPropagation()}
            className="bg-white border-4 border-black shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] p-8 max-w-md w-full relative"
          >
            <button onClick={onClose} className="absolute top-4 right-4 hover:rotate-90 transition-transform">
              <X size={24} />
            </button>
            
            <div className="flex flex-col items-center text-center">
              <div className="bg-[#A0E7E5] p-4 rounded-full border-2 border-black mb-6 shadow-[4px_4px_0px_0px_black]">
                <CheckCircle size={48} className="text-black" />
              </div>
              
              <h2 className="text-3xl font-black uppercase mb-4">MESSAGE RECEIVED!</h2>
              <p className="text-lg font-medium text-gray-600 mb-8">
                We've got your details. Our team is already brainstorming how to make your project legendary. 
                Expect a ping soon!
              </p>
              
              <button 
                onClick={onClose}
                className="bg-[#FFD233] text-black w-full py-4 font-black uppercase tracking-wider border-2 border-black shadow-[4px_4px_0px_0px_black] hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[2px_2px_0px_0px_black] active:translate-x-[4px] active:translate-y-[4px] active:shadow-none transition-all"
              >
                Let's Go 🚀
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ThankYouPopup;
